﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global } from "../Common/saop-common";
import { SaopTranslationService } from "../Core/saop-translate";
import { SaopViewFormBindings } from "../Core/saop-view-form-bindings";
import { SaopWfSubmitResult } from "../core/saop-view-form";


export class SaopRegCurrentEventView extends SaopViewFormBindings {
    public translationService:SaopTranslationService = new SaopTranslationService();
    constructor(viewId: string, libName: string = "") {
        super(viewId, libName);
        this.setTerminologyList();
    }

    public setTerminologyList() {
        let _terminology = ["Za prikaz gumbov je potrebno omogočiti dostop do lokacije!"];
        this.translationService.setTranslationsList(_terminology);
    }   

    onSubmitSuccess(data: SaopWfSubmitResult): void {
        global.ConsoleLogDegug("SaopRegCurrentEventView.onAddDataSuccess");
        if (data.success) {
            alertify.message(data.alertMessage);
        }
        else{
            alertify.error(data.alertMessage);
        }
        this.afterSubmitSuccess(data);
    }

    public afterSubmitSuccess(result: SaopWfSubmitResult): void {
        global.ConsoleLogDegug("SaopRegCurrentEventView.afterExecuteSuccess");
    }   

    getCurrentPosition(): void {
        let _this = this;
        const upostevajGeo = (document.getElementById("RegUraAcctionButtonsViewModel_UpostevajGeolokacijo") as HTMLInputElement)?.value;

        if (upostevajGeo === "False") {
            return;
        }

        const buttonGroup = document.getElementById("tekociDogodkiButtonGroup") as HTMLElement;
        const geoField = document.getElementById("Geolokacija") as HTMLInputElement;

        buttonGroup.style.display = "none";
        geoField.value = "";

        navigator.geolocation.getCurrentPosition(
            position => {
                
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`)
                    .then(r => r.json())
                    .then(data => {

                        const addr = data.address || {};
                        const city = addr.city || addr.town || addr.village || "";
                        const country = addr.country || "";

                        // if (!city || !country ) {
                        //     const geolocation = { latitude, longitude};
                        //     geoField.value = JSON.stringify(geolocation);
                        //     //console.log("GEO:", geoField.value);
                        //     buttonGroup.style.display = "block";
                        //     return;
                        // }
                        
                        const geolocation = { latitude, longitude, city, country };
                        geoField.value = JSON.stringify(geolocation);
                        //console.log("GEO:", geoField.value);
                        buttonGroup.style.display = "block";
                    })
                    .catch(() => {
                        const geolocation = { latitude, longitude};
                        geoField.value = JSON.stringify(geolocation);
                        buttonGroup.style.display = "none";
                    });
            },

            () => {
                geoField.value = "";
                buttonGroup.style.display = "none";

                const $buttonGroup = $("#tekociDogodkiButtonGroup");
                $buttonGroup.html(`
                    <span style="
                        font-weight:600;
                        font-size:16px;
                        line-height:24px;
                        color:#D82C25;
                    ">
                    ${this.translationService.translate("Za prikaz gumbov je potrebno omogočiti dostop do lokacije!")}
                    </span>
                `);
            }
        );
    //
    }

}